import {IssuesLoadingSkeleton} from '@github-ui/issues-loading-skeleton'

import styles from './FormElementLoading.module.css'

export const FormElementLoading = () => {
  return (
    <div className={styles.loadingSkeletonContainer}>
      <IssuesLoadingSkeleton borderRadius="pill" height="lg" width="400px" />
    </div>
  )
}

try{ FormElementLoading.displayName ||= 'FormElementLoading' } catch {}